export default __webpack_public_path__ + "static/1677-626f6ed2a88aa4759dd789a6997db082.gif";